<style lang="scss">





@media screen and (min-width: 55rem) {
  .future-goals {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    // background-color: cornflowerblue;
    .future-goals-container {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .future-goals-top {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .future-goals-top-title {
          color: #e5004f;
          font-size: 2rem;
          font-family:  'PingFang SC','Microsoft YaHei';
        }
        .future-goals-top-subtitle {
          color: #7d7d7d;
          font-size: 1rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          margin-bottom: 1rem;
          text-transform: uppercase;
        }
        .future-goals-top-line {
          width: 2rem;
          height: 0.4rem;
          background-color: #e5004f;
          margin-bottom: 4rem;
          margin-top: 1rem;
        }
      }
      .future-goals-bottom {
        .future-goals-bottom-text {
          color: #4b4b4b;
          font-size: 1.4rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          margin-top: 1rem;
        }
      }
      .future-goals-list {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        // margin-top: 5rem;

        .future-goals-item {
          width: 30%;
          height: 25rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          .future-goals-top {
            height: 50%;
            width: 100%;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
          }
          .future-goals-title {
            text-align: center;
            color: #333333;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-size: 1.4rem;
            margin-top: 0.6rem;
            margin-bottom: 0.6rem;
          }
          .future-goals-text {
            text-align: center;
            font-size: 1rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            color: #7f7f7f;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 55rem) {
  .future-goals {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    // background-color: cornflowerblue;

    .future-goals-container {
      width: 80%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .future-goals-top {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .future-goals-top-title {
          color: #e5004f;
          font-size: 2.6rem;
          font-family:  'PingFang SC','Microsoft YaHei';
        }
        .future-goals-top-subtitle {
          color: #7d7d7d;
          font-size: 1rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          margin-bottom: 1rem;
          text-transform: uppercase;
        }
        .future-goals-top-line {
          width: 2rem;
          height: 0.4rem;
          background-color: #e5004f;
          margin-bottom: 4rem;
          margin-top: 1rem;
        }
      }
      .future-goals-bottom {
        .future-goals-bottom-text {
          color: #4b4b4b;
          font-size: 1.4rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          margin-top: 1rem;
        }
      }
      .future-goals-list {
        width: 100%;
        display: flex;
        flex-direction: column;
        // margin-top: 5rem;

        .future-goals-item {
          width: 100%;
          height: 25rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;

          .future-goals-top {
            height: 50%;
            width: 100%;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
          }
          .future-goals-title {
            text-align: center;
            color: #333333;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-size: 1.4rem;
            margin-top: 0.6rem;
            margin-bottom: 0.6rem;
          }
          .future-goals-text {
            text-align: center;
            font-size: 1rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            color: #7f7f7f;
          }
        }
      }
    }
  }
}
</style>

<template>
  <div class="future-goals">
    <div class="future-goals-container">
      <div class="future-goals-top">
        <div class="future-goals-top-title">未来可期</div>
        <div class="future-goals-top-subtitle">Future Goals</div>
        <div class="future-goals-top-line"></div>
      </div>
      <!--<div class="future-goals-bottom">
        <div class="future-goals-bottom-text">
          2019年宣布，未来五年将再造一个银泰百货
        </div>
        <div class="future-goals-bottom-text">
          “打造1000个坪效翻番的新零售品牌”
        </div>
        <div class="future-goals-bottom-text">
          “打造100个年销千万的新零售商品”
        </div>
        <div class="future-goals-bottom-text">“打造100个年薪百万的导购”</div>
      </div>-->

      <div class="future-goals-list">
        <!--<div class="future-goals-item">
          <div
            class="future-goals-top"
            style="background-image: url('/media/yintai/futuregoal-1.jpeg')"
          ></div>
          <div class="future-goals-title">新零售战略</div>
          <div class="future-goals-text">
            2017-2020年，银泰百货在由内到外的数字化转型升级过程中，呈现出高于行业的商业活力，以及与其他百货公司截然不同的成长动力。通过阿里商业操作系统的赋能，银泰正在系统重构人——数字化会员破千万、货——商品和品牌全面数字化、场——通过云计算提升运营效率、创新服务方式，成为领先的“新零售百货”。
          </div>
        </div>-->
        <div class="future-goals-item">
          <div
            class="future-goals-top"
            style="background-image: url('/media/yintai/futuregoal-1.jpeg')"
          ></div>
          <div class="future-goals-title">数字化转型升级</div>
          <div class="future-goals-text">
            2018年以来，银泰百货开展数字化转型升级至今。人——数字化会员突破4000万；导购、员工都被数字化在钉钉上；货——商品和品牌全面数字化；场——通过云计算提升运营效率、创新服务方式，成为领先的“互联网百货公司”。并将这些经验沉淀为“新商场商业操作系统（MOS系统），向行业输出。
          </div>
        </div>

        <div class="future-goals-item">
          <div
            class="future-goals-top"
            style="background-image: url('/media/yintai/futuregoal-2.jpeg')"
          ></div>
          <div class="future-goals-title">深层变化</div>
          <div class="future-goals-text">
            走进深水区、全面拥抱数字化的战略决策，显著提升流程的数字化程度，为一线工作人员配备简单好用的数字化分析工具，以小步迭代的方式快速引进新服务。
            在细节繁多、变化微妙、结构坚固的百货行业，银泰的新零售实践树立了一种全新的发展样本。
          </div>
        </div>

        <div class="future-goals-item">
          <div
            class="future-goals-top"
            style="background-image: url('/media/yintai/futuregoal-3.jpeg')"
          ></div>
          <div class="future-goals-title">全面上云</div>
          <div class="future-goals-text">
            银泰100%云化，意味着整个银泰的基础设施已经发生了质变，基于百货行业的复杂商业操作系统完成了从0到1的使命，让银泰成为全国首家完全云化的百货公司。从此，跑在云上的银泰，将通过云计算进一步放大业务规模，彰显其日益强大的技术支撑能力。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "future",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
